<template>
    <div class="relative flex">
        <transition name="bounce" mode="out-in">
            <form v-if="!isSubmitted" class="flex" @submit.prevent="subscribeNewsletter">
                <UInput type="email" placeholder="Your email address" v-model="form.EMAIL"
                    icon="heroicons:at-symbol-16-solid"
                    :ui="{ rounded: 'rounded-l-lg rounded-r-none', base: ' bg-red-500' }" size="lg" required />
                <button type="submit"
                    class="bg-primary-500 hover:bg-primary-700 transition rounded-r-lg px-4 flex items-center gap-1">
                    <span v-if="submitText" class="whitespace-nowrap hidden md:inline">{{ submitText }}</span>
                    <Icon name="heroicons:arrow-right-16-solid" />
                </button>
            </form>

            <div v-else class="bg-primary-500 p-3 text-center font-bold rounded-md whitespace-nowrap">
                🎉 Thanks for subscribing!
            </div>
        </transition>
    </div>
</template>

<script setup>
const props = defineProps({
    submitText: String
})
const form = ref({
    EMAIL: "",
    tags: "12755625"
})
const isSubmitted = useState("newsletter-submitted", () => false)
const subscribeNewsletter = (ev) => {
    ev.preventDefault()

    fetch("https://pathway.us12.list-manage.com/subscribe/post?u=70279b5d6def5ed7bf629c1f3&amp;id=5c64b9d355&amp;f_id=00ccc0e8f0", {
        method: "POST",
        body: new URLSearchParams(form.value),
        mode: "no-cors",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        }
    }).then(() => {
        const { $showToast } = useNuxtApp()
        isSubmitted.value = true
        $showToast(`Thank you, we will send fresh articles to ${form.value.EMAIL}!`, 'success', 3000)
        form.value.EMAIL = ""
    }).catch((err) => {
        console.error("[Newsletter Error]", err)
    })
}
</script>
